import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { genColHeaderName, sortObjArr } from 'utils/functions';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from 'components/Tooltip';
import { handleError } from 'reducers/ErrorReducer';
import LinearProgress from '@material-ui/core/LinearProgress';
import { displayDateTime } from 'reducers/TimeReducer';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { showEditPlace } from 'reducers/DialogsReducer';

const useStyles = makeStyles((theme) => ({
  table: {
    width: '100%',
    border: `1px solid ${theme.colors.grey1}`,
    borderRight: 'none',
    '& th': {
      borderRight: 'none',
      padding: '2px 15px',
      '&:nth-child(1)': {
        width: '20%',
      },
      '&:nth-child(2)': {
        width: '30%',
      },
      '&:nth-child(3)': {
        width: '30%',
      },
    },
    '& td': {
      borderRight: 'none',
      padding: '2px 15px',
      height: 33,
      '&:nth-child(1)': {
        width: '20%',
      },
      '&:nth-child(2)': {
        width: '30%',
      },
      '&:nth-child(3)': {
        width: '30%',
      },
    },
  },
  radioGroup: {
    flexDirection: 'row',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 16,
    forntSize: 16,
  },
  tableAction: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  loading: {
    paddingTop: 12,
    marginTop: -16,
    width: '100%',
    height: 16,
  },
  title: {
    textAlign: 'center',
    color: 'red',
    fontSize: '15px',
    fontWeight: 500,
    margin: '0px 0',
  },
  splitContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  leftPane: {
    width: '50%',
    paddingRight: 8, // optional spacing
  },
  rightPane: {
    width: '50%',
    paddingLeft: 8, // optional spacing
  },

  rightcontainer: {
    padding: 10,
    position: 'relative',
    height: '100%',
  },

  redLine: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    background: 'red',
    borderRadius: 4,
  },

  listWrapper: {
    marginLeft: '20px',
    paddingTop: '20px',
    width: '100%',
  },

  listRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 15px',
    color: 'red',
    fontSize: 14,
    fontWeight: 500,
    gap: 10,
  },

  leftText: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },

  code: {
    fontWeight: 600,
  },

  actions: {
    color: '#0153a3',
    display: 'flex',
    alignItems: 'center',
    gap: 10,

    '& svg': {
      cursor: 'pointer',
    },
  },
  targetaction: {
    color: '#0153a3',
    gap: 10,
    cursor: 'pointer',
    float: 'right',
  },
}));

const dataColumns = [
  'Flags',
  'IsDeleted',
  'IsDestination',
  'PlaceDepartmentID',
  'PlaceName',
  'PlaceORI',
  'PlaceType',
];

function valToStr(val) {
  if (val === null) return 'null';
  if (typeof val === 'string' || typeof val === 'number') return '' + val;
  if (val === false) return 'false';
  if (val === true) return 'true';
  if (val instanceof Date) return displayDateTime(val);
  return 'unknown format!';
}

function PlaceMerge(props) {
  const { rows, source, setSource, target, setTarget, data, setData, loading } = props;
  const classes = useStyles();
  const mountedRef = useRef(true);

  useEffect(() => {
    getData();
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const getData = async () => {
    let sources = rows.filter((row) => props.sourceID.includes(row.ptsPlaceID));
    let target = rows.find((row) => row.id === props.targetID);
    setSource(sources);
    setTarget(target);
    let data = processData(sources, target);
    data = sortObjArr(data, 'field');
    setData(data);
  };

  const processData = (sources, target) => {
    const data = dataColumns.map((field) => {
      const targetVal = target[field];
      const obj = {
        field,
        isTargetVal: true,
        headerName: genColHeaderName(field),
        targetVal,
        targetStrVal: valToStr(targetVal),
      };
      return obj;
    });
    return data;
  };

  const renderRows = () => {
    let filteredData = data;
    const withAddressData = filteredData.map((row) => {
      if (row.field === 'ptsAddressID') {
        return {
          ...row,
          headerName: 'Address',
          targetStrVal: target.FullAddressText || 'null',
        };
      }
      return row;
    });

    return withAddressData.map((row) => (
      <TableRow key={row.field}>
        <TableCell>{row.headerName}</TableCell>
        <TableCell>
          <label htmlFor={'target-' + row.field}>{row.targetStrVal}</label>
        </TableCell>
      </TableRow>
    ));
  };
  const onEditClick = (item) => {
    const { ptsPlaceID } = item;
    props.showEditPlace({ ptsPlaceID, ptsAddressID: null });
  };
  const onRemoveClick = (id) => {
    setSource((prev) => prev.filter((x) => x.PlaceID !== id));
  };
  const renderPlaceRows = () => {
    return (
      <div className={classes.rightcontainer}>
        <div className={classes.redLine} />
        <div className={classes.listWrapper}>
          {source?.map((item, index) => (
            <div key={index} className={classes.listRow}>
              <div className={classes.leftText}>
                <span className={classes.code}>{item.PlaceID}</span>
                <span>{item.PlaceName}</span>
              </div>

              <div className={classes.actions}>
                <Tooltip title="Edit Place" className="ml-2">
                  <EditIcon onClick={() => onEditClick(item)} />
                </Tooltip>
                <Tooltip title="Remove Place" className="ml-2">
                  <RemoveCircleOutlineIcon onClick={() => onRemoveClick(item.PlaceID)} />
                </Tooltip>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderTable = () => {
    return (
      <>
        <div className={classes.title}>Keep</div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Place Record</TableCell>
              <TableCell>
                {target.PlaceName} <br />
                <small>(will be updated)</small>
              </TableCell>
            </TableRow>
          </TableHead>
          <tbody>
            <TableRow>
              <TableCell>Place ID</TableCell>
              <TableCell>
                {target.PlaceID}
                <span className={classes.targetaction}>
                  <Tooltip title="Edit Place">
                    <EditIcon onClick={() => onEditClick(target)} />
                  </Tooltip>
                </span>
              </TableCell>
            </TableRow>
            {renderRows()}
          </tbody>
        </Table>
      </>
    );
  };

  const renderTable2 = () => {
    return (
      <>
        <div className={classes.title}>Replace ({source.length})</div>
        {renderPlaceRows()}
      </>
    );
  };

  return (
    <div>
      <div className={classes.loading}>{loading && <LinearProgress />}</div>

      {Boolean(source && target && !loading) && (
        <div className={classes.splitContainer}>
          <div className={classes.leftPane}>{renderTable()}</div>
          <div className={classes.rightPane}>{renderTable2()}</div>
        </div>
      )}
    </div>
  );
}

export default connect(null, { handleError, showEditPlace })(PlaceMerge);
